import { debounce } from 'lodash';

import { getAlternateLogo } from "../../utils";
import { ROUTES } from '../../constants/routes';

import { ACTIONS } from './reducer';

export const getThemeDetails = (themeData) => {
  const themeDetails = { logo: '', siteTitle: '', alternateLogo: '', shouldDisplayVersion: null };
  if (!themeData) {
    return themeDetails;
  }
  
  const { logo, siteTitle, display } = themeData;
  themeDetails.logo = logo;
  themeDetails.alternateLogo = getAlternateLogo(siteTitle);
  themeDetails.siteTitle = siteTitle;
  
  if (display && display.versionNumber) {
    themeDetails.shouldDisplayVersion = true;
  }
  
  return themeDetails;
}
  
export const validateFieldValue = debounce(({ field, dispatch, intl }) => {
  dispatch({ type: ACTIONS.UPDATE_FIELD_ERRORS, payload: { field, intl } })
}, 300);
  
export const goToRegistrationPage = () => window.location.href = ROUTES.registerationRedirect.path;
export const goToHomePage = () => window.location.href = ROUTES.homeRedirect.path;
export const goToPreviousPage = () => window.history.back();
export const goToResetPasswordPage = () => {
  window.location.href = ROUTES.forgotPasswordRedirect.path;
};

export const isEnhancedPasswordSecurityEnabled = (authScheme) => {
  if (!authScheme.advancedConfigurations) return false;
  if (!authScheme.advancedConfigurations.enhancedPasswordSecurity) return false;
  
  const enhancedPasswordSecurity = authScheme.advancedConfigurations.enhancedPasswordSecurity;
  if (typeof(enhancedPasswordSecurity) !== "string") return false;
  if (enhancedPasswordSecurity.toLowerCase() !== "yes") return false;
  
  return true;
};
  
const goodProtocols = [
  "/",
  "http://",
  "https://",
];

export const isProtocolInWhitelist = function(url) {
  return goodProtocols.some((protocol) => {
    if (url.startsWith(protocol)) return true;
  });
};

export const isPublicKeyValid = (publicKey) => {
  return (publicKey && (publicKey !== 'EMPTY'));
}